// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.bots_title_component {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
}

.bots_container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.bots_multi_box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    gap: 20px;
}

.bots_chiffres_user {
    width: 35%;
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-md);
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
}

.bots_multi_box_container {
    width: 50%;
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-md);
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
}

.bots_container_title {
    margin: 0 0 16px 0;
    font-size: 18px;
    font-weight: 600;
    color: var(--text-primary);
}

.bots_row_space_between_box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}

.bots_box {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.bots_item_desc {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
}

.bots_item_title {
    margin: 0;
    font-size: 13px;
    display: block;
    color: var(--text-muted);
}

.bots_p {
    margin: 5px 0;
}

.bots_table_filter_container {
    display: flex;
    flex-direction: row;
    justify-content: end;
}

.bots_date_contaier {
    display: flex;
    flex-direction: row;
    justify-content: center;
    line-height: 4rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/bots/bots.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB","sourcesContent":["\n.bots_title_component {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.bots_container {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.bots_multi_box {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: stretch;\n    gap: 20px;\n}\n\n.bots_chiffres_user {\n    width: 35%;\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n}\n\n.bots_multi_box_container {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n}\n\n.bots_container_title {\n    margin: 0 0 16px 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.bots_row_space_between_box {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n}\n\n.bots_box {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.bots_item_desc {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.bots_item_title {\n    margin: 0;\n    font-size: 13px;\n    display: block;\n    color: var(--text-muted);\n}\n\n.bots_p {\n    margin: 5px 0;\n}\n\n.bots_table_filter_container {\n    display: flex;\n    flex-direction: row;\n    justify-content: end;\n}\n\n.bots_date_contaier {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    line-height: 4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
